module.exports = {"id":"164859","name":"Theo Walcott","rating":"79","photo":"./data/images/photos/1/164859.png","club":{"name":"Everton","logo":"./data/images/clubs/Everton.png"},"positions":["MD","AD","MG"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/TheoWalcott0.json
// module id = 4090
// module chunks = 0